import { yupResolver } from '@hookform/resolvers/yup';
import { Resolver } from 'react-hook-form';
import { CreateServiceT } from 'shared/api/types/services';
import * as Yup from 'yup';
import initDefaultSchema from '../yupConfig';

initDefaultSchema();

// Create Service
export type CreateServiceFormT = CreateServiceT['request'];
export const getCreateServiceValues = (): CreateServiceFormT => ({
  name: '',
  domain: '',
  token: '',
});
const createServiceSchema: Yup.ObjectSchema<CreateServiceFormT> = Yup.object({
  name: Yup.string().required(),
  domain: Yup.string().required(),
  token: Yup.string().required(),
});
export const createServiceResolver = yupResolver(createServiceSchema) as Resolver<CreateServiceFormT>;
